module.exports = __webpack_public_path__ + "3774fdb3534c0a05308aa38b53c0657f.png";